import React from "react";

const RestartCard = () => {
  return (
    <section className="restart-card-section" aria-labelledby="restart-card-title">
      <div className="restart-card-shell">
        <img
          src="/Restcard1img.png"
          alt="Books and graduation cap illustration"
          className="restart-card-image restart-card-image-left"
        />

        <div className="restart-card-content">
          {/* <p className="restart-card-kicker">Ready to Start Your Preparation?</p> */}
          <h2 id="restart-card-title" className="restart-card-title">
            Ready to Start Your Preparation?
          </h2>
          <p className="restart-card-text">
            Join thousands of students preparing for India&apos;s top entrance examinations with
            eGRADTutor&apos;s comprehensive learning platform.
          </p>
         <button
  type="button"
  className="restart-card-button"
  onClick={() => window.open("https://onlinepg.egradtutor.in", "_blank")}
>
  Start Learning Now
</button>
        </div>

        <img
          src="/Restcard2img.png"
          alt="Books, chart and trophy illustration"
          className="restart-card-image restart-card-image-right"
        />
      </div>
    </section>
  );
};

export default RestartCard;
